<template>
  <div class="home"></div>
</template>
<script>
import appIconImage from "../assets/logo.png";

export default {
  name: "Home",
  components: {},
  beforeCreate() {
    let locale = this.$route.params.lang
      ? this.$route.params.lang
      : this.$route.query.lang;
    if (locale && locale.length > 0) {
      localStorage.setItem("locale", locale);
      this.$i18n.locale = locale;
    }
  },
  data: function() {
    return {
      shareTitle: this.$i18n.t("title"),
      shareDescription: this.$i18n.t("description"),
      shareImage: process.env.VUE_APP_DOMAIN + appIconImage
    };
  },
  metaInfo() {
    return {
      title: this.shareTitle,
      meta: [
        {
          name: "description",
          content: this.shareDescription
        },
        {
          property: "og:title",
          content: this.shareTitle
        },
        {
          property: "og:description",
          content: this.shareDescription
        },
        {
          property: "og:image",
          content: this.shareImage
        },
        {
          name: "twitter:card",
          content: "summary"
        }
      ]
    };
  },
  methods: {}
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}
</style>
